module.exports = __webpack_public_path__ + "img/sourcing.65c0760c.svg";